<template>
    <CCard bodyWrapper>
        <h6>
            {{ $t("Configure the optin to get a validation by sms or email") }}
        </h6>
        <CRow>
            <label class="col-form-label col-sm-2 col-form-label-sm"
                >{{ $t("active") }}:</label
            >

            <CCol sm="10" class="input-group-sm">
                <LInputRadioGroup
                    :isValid="
                        checkIfOptinValid({
                            fieldName: 'active',
                        })
                    "
                    :checked.sync="$v.forms.optin.active.$model"
                    :options="[
                        {
                            value: true,
                            label: 'Yes',
                        },
                        {
                            value: false,
                            label: 'No',
                        },
                    ]"
                    :inline="true"
                    @change="changeOptinActive()"
                />
            </CCol>
        </CRow>
        <CInput
            :isValid="
                checkIfOptinValid({
                    fieldName: 'landingTitle',
                })
            "
            :label="$t('Landing title')"
            :placeholder="$t('Thank you very much...')"
            :invalidFeedback="$t('Name is required')"
            :horizontal="default_horizontal"
            size="sm"
            :value.sync="$v.forms.optin.landingTitle.$model"
        />
        <CTextarea
            :isValid="
                checkIfOptinValid({
                    fieldName: 'landingMessage',
                })
            "
            :label="$t('Landing message')"
            :placeholder="$t('We have validated your data...')"
            :invalidFeedback="$t('Message is required')"
            :horizontal="default_horizontal"
            size="sm"
            :value.sync="$v.forms.optin.landingMessage.$model"
        />
        <div role="group" class="form-group form-row">
            <label
                for="uid-5klclxmziv2"
                class="col-form-label col-sm-2 col-form-label-sm"
            >
                Landing Logo
            </label>
            <div class="col-sm-10 input-group-sm">
                <input
                    id="uid-5klclxmziv2"
                    class="fileImage form-control border-0 p-0"
                    type="file"
                    accept="image/*"
                    @change="previewFile"
                />
                <img
                    v-if="forms.optin.landingLogo"
                    v-bind:src="forms.optin.landingLogo"
                    class="imgPreview mt-2"
                />
            </div>
        </div>
    </CCard>
</template>

<script>
import LInputRadioGroup from "~/components/LInputRadioGroup";
import pageMixin from "~/mixins/page.js";
import { required } from "vuelidate/lib/validators";
import { requiredIf } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";
import axios from "axios";
import store from "~/store";
import { mapGetters } from "vuex";

export default {
    name: "OptinTab",
    mixins: [pageMixin, validationMixin],
    icons: {},
    consts: {},
    options: {},
    components: {
        LInputRadioGroup,
    },
    data() {
        return {
            forms: {
                optin: {
                    active: false,
                    landingTitle: "",
                    landingMessage: "",
                    landingLogo: "",
                },
            },
            files: [],
        };
    },
    validations: {
        forms: {
            optin: {
                active: {
                    required,
                },
                landingTitle: {
                    required: requiredIf(function (nestedModel) {
                        return nestedModel.active === true;
                    }),
                },
                landingMessage: {
                    required: requiredIf(function (nestedModel) {
                        return nestedModel.active === true;
                    }),
                },
                landingLogo: {},
            },
        },
        imageTmp: {},
    },
    computed: {
        ...mapGetters({
            user: "auth/user",
        }),
        baseURL: function () {
            let baseURL = axios.defaults.baseURL;
            if (
                this.user &&
                this.user["custom:tenant_id"] &&
                (process.env.VUE_APP_API_MODE === "prod" ||
                    process.env.VUE_APP_API_MODE === "pre") &&
                baseURL !== process.env.VUE_APP_API_AUTH
            ) {
                baseURL = baseURL + "/" + this.user["custom:tenant_id"];
            }
            return baseURL;
        },
    },
    props: {
        providerUuid: {
            required: true,
        },
        providerId: {
            required: true,
        },
    },
    watch: {},
    methods: {
        async loadOptinDetails() {
            try {
                const resp = await this.fetcher({
                    baseURL: process.env.VUE_APP_API_SASS,
                    url: "/optin/config/" + this.providerUuid,
                });
                this.assingValues(resp);
            } catch (error) {
                this.showMessageError(error);
            }
        },
        async assingValues(newValue) {
            if (newValue.active != undefined)
                this.forms.optin.active = newValue.active;
            if (newValue.landingTitle != undefined)
                this.forms.optin.landingTitle = newValue.landingTitle;
            if (newValue.landingMessage != undefined)
                this.forms.optin.landingMessage = newValue.landingMessage;
            if (newValue.landingLogo != undefined)
                this.forms.optin.landingLogo = newValue.landingLogo;
        },
        async isInvalid() {
            let valForm = this.$v.forms.optin;
            if (!valForm) return false;
            valForm.$touch();
            return valForm.$invalid;
        },
        changeOptinActive() {
            this.$v.$reset();
        },
        async sendData(insertId, method) {
            let uuid = this.providerUuid;
            if (insertId) {
                uuid = insertId;
            }

            await this.uploadFile(uuid);

            await this.fetcher({
                baseURL: process.env.VUE_APP_API_SASS,
                url: "/optin/config/" + uuid,
                method: method,
                data: {
                    tenantId: parseInt(this.user["custom:tenant_id"]),
                    ...this.forms.optin,
                },
            });
        },
        checkIfOptinValid({ fieldName }) {
            const field = this.$v.forms.optin[fieldName];
            if (!field.$dirty) {
                return null;
            }
            return !field.$invalid;
        },
        previewFile(event) {
            this.files = event.target.files;
        },
        async uploadFile(uuid) {
            let formData = new FormData();
            if (this.files.length > 0) {
                for (let i = 0; i < this.files.length; i++) {
                    const file = this.files[i];
                    let newFile = new File(
                        [file],
                        `${Date.now()} - ${file.name}`,
                        {
                            type: "image/png",
                        }
                    );
                    formData.append("file", newFile);
                }

                let response = await fetch(
                    `${this.baseURL}/upload/resource?type=img_optin`,
                    {
                        method: "POST",
                        headers: {
                            Authorization: `Bearer ${store.getters["auth/token"]}`,
                        },
                        dataType: "json",
                        mimeType: "multipart/form-data",
                        mode: "cors",
                        credentials: "include",
                        body: formData,
                    }
                )
                    .then(async (response) => {
                        let dataMain = await response.json();
                        this.forms.optin.landingLogo = dataMain.url;
                        return dataMain;
                    })
                    .catch(function (error) {
                        return error;
                    });
            }
        },
    },
    async mounted() {
        //await this.loadOptinDetails();
    },
};
</script>

<style>
.fileImage input {
    border: 0;
    padding: 0;
}
.imgPreview {
    width: 100px !important;
}
</style>
